var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:{ 'drag-over': _setup.isDragOver },on:{"dragover":_setup.onDragover,"dragleave":_setup.onDragleave,"drop":_setup.onDrop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }